import { useState, useRef } from "react";
import { Input } from "antd";

function SentenceEngInput ({_, record, singleChange, field}) {
  const [text, setText] = useState(_)
  const compareRef = useRef()
  return (
    <Input
          style={{
            border:
            text === record[`${field}_origin`] ? "" : "solid 2px red",
          }}
          defaultValue={text}
          value={text}
          onChange={(e) => {
            const newText = e.target.value;
            setText(newText)
          }}
          onFocus={() => {
            compareRef.current = text;
          }}
          onBlur={() => {
            if (compareRef.current !== text) {
              singleChange(text, record, field);
            }
            compareRef.current = null;
          }}
        />
  )
}

export default SentenceEngInput